import { useGetApiChatBotDataGet, useGetApiWorkspaceGet } from "@/API";
import { Breadcrumbs, Text, Group, LoadingOverlay, Stack } from "@mantine/core";
import { Link, useParams } from "@tanstack/react-router";
import { ChatBot } from "./ChatBot";
import { AppBreadcrumbs } from "@/Components/AppBreadcrumbs";

export function ChatBotPage(props: { chatBotId: string }) {
    const { workspaceId, chatBotDataId } = useParams({ from: "/workspace/$workspaceId/chatBotData/$chatBotDataId/chat" })
    const workspace = useGetApiWorkspaceGet({ id: workspaceId })
    const chatBotData = useGetApiChatBotDataGet({ workspaceId: workspaceId, id: props.chatBotId })

    return <>
        <Stack pos="relative" gap={0} h="calc(100vh - var(--app-shell-header-height, 0px) - var(--app-shell-footer-height, 0px) - var(--app-shell-padding) * 2)">
            <LoadingOverlay visible={chatBotData.isFetching} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
            <AppBreadcrumbs
                items={[
                    {
                        label: '工作空間列表',
                        linkProps: { to: '/workspace' },
                    },
                    {
                        label: workspace.data?.data.name ?? '',
                        linkProps: { to: '/workspace/$workspaceId', params: { workspaceId } },
                    },
                    {
                        label: "機器人設定",
                        linkProps: { to: '/workspace/$workspaceId/chatBotData', params: { workspaceId } },
                    },
                    {
                        label: chatBotData.data?.data.name,
                        linkProps: {
                            to: '/workspace/$workspaceId/chatBotData/$chatBotDataId', params: {
                                workspaceId: workspaceId,
                                chatBotDataId: chatBotData.data?.data.id ?? ""
                            }
                        },
                    },
                    {
                        label: "聊天測試",
                        active: true,
                    }
                ]}
            />
            {
                chatBotData.data?.data.id && chatBotData.data?.data.chatConfig &&
                <ChatBot workspaceId={workspaceId} chatBotDataId={chatBotData.data?.data.id} chatConfig={chatBotData.data?.data.chatConfig} exportName={chatBotData.data?.data.name ?? ""} featureConfig={{
                    chatRepetition: true
                }} />
            }
        </Stack>
    </>
}